import React from 'react';
import { Box, Flex, Text, Button, VStack } from '@chakra-ui/react';
export function HeroSection() {
  return <Box as="section" position="relative" w="100%" minH={{
    base: '520px',
    md: '680px',
    lg: '780px'
  }} overflow="hidden" className="lace-border-bottom" data-id="element-100">
      {/* Background image placeholder */}
      <Box position="absolute" inset={0} className="hero-parallax" backgroundImage="url('https://cdn.magicpatterns.com/uploads/tMGEqYHPZK9VdUDg7cebTM/628091874_18078259421599200_8108600134809484757_n.jpg')" backgroundSize="cover" backgroundPosition="center top" data-id="element-101" />

      {/* Pink overlay */}
      <Box position="absolute" inset={0} bg="rgba(244,184,193,0.28)" data-id="element-102" />

      {/* Gradient overlay for text legibility */}
      <Box position="absolute" inset={0} bgGradient="linear(to-b, rgba(0,0,0,0.1) 0%, rgba(0,0,0,0.50) 60%, rgba(0,0,0,0.65) 100%)" data-id="element-103" />

      {/* Content */}
      <Flex position="relative" zIndex={1} align="center" justify="center" minH={{
      base: '520px',
      md: '680px',
      lg: '780px'
    }} px={{
      base: 6,
      md: 12
    }} py={{
      base: 16,
      md: 20
    }} data-id="element-104">
        <VStack spacing={6} textAlign="center" maxW="700px" data-id="element-105">
          {/* Script accent */}
          <Text className="font-script" fontSize={{
          base: '22px',
          md: '28px'
        }} color="rgba(255,255,255,0.9)" letterSpacing="0.02em" data-id="element-106">
            Welcome to
          </Text>

          {/* Main headline */}
          <Text as="h1" className="font-serif" fontSize={{
          base: '32px',
          md: '48px',
          lg: '56px'
        }} fontWeight={700} color="white" lineHeight={1.2} style={{
          textShadow: '0 2px 12px rgba(0,0,0,0.6)'
        }} data-id="element-107">
            Fashion with Faith & Purpose
          </Text>

          {/* Subheadline */}
          <Text className="font-body" fontSize={{
          base: '16px',
          md: '18px'
        }} color="rgba(255,255,255,0.92)" lineHeight={1.7} maxW="560px" style={{
          textShadow: '0 1px 6px rgba(0,0,0,0.5)'
        }} data-id="element-108">
            Vintage. Upcycled. One-of-a-kind pieces made to glorify Him and
            spread love to you.
          </Text>

          {/* CTA Button */}
          <Button bg="#C9929D" color="white" fontSize={{
          base: '15px',
          md: '16px'
        }} fontWeight={600} px={10} h="52px" borderRadius="24px" className="font-body" _hover={{
          bg: '#b8818c',
          transform: 'translateY(-2px)',
          boxShadow: '0 6px 20px rgba(201,146,157,0.4)'
        }} _active={{
          bg: '#a87080'
        }} transition="all 0.25s" w={{
          base: '100%',
          sm: 'auto'
        }} minW={{
          sm: '220px'
        }} data-id="element-109">
            Shop the Collection
          </Button>

          {/* Script signature */}
          <Text className="font-script" fontSize={{
          base: '20px',
          md: '24px'
        }} color="rgba(255,255,255,0.88)" mt={-2} data-id="element-110">
            Lots of Love & xx's 💕
          </Text>
        </VStack>
      </Flex>
    </Box>;
}